<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading...">
  </mat-progress-bar>
</section>

<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start" *ngIf="!loading">
  <div fxFlex="100.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
    <button mat-button mat-dialog-close="Cancel" aria-label="Cancel" [disabled]='processing || loading'>Close</button>
  </div>
</div>
<mat-dialog-content>
  <div *ngIf="!loading">
    <household-edit [householdId]="householdId"></household-edit>
  </div>
</mat-dialog-content>